import { AuthConfig } from '@auth0/auth0-angular';

import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = environment.auth;
